import * as React from 'react';
import { IEmail } from '../../../Types';
import * as userStore from '../../../../../../../shared/UserStore';
import { Translate } from '../../../../../../../shared/LanguageService';
import { ButtonToolbar, Button } from 'react-bootstrap';
import DateTimeView from '../../../../../../../features/localDate/DateTimeView';

interface IProps {
    item: IEmail;
    key: number;
    onView: (email: IEmail) => void;
}

const EmailListRow = (props: IProps) => {
    return (
        <tr>
            <td>{props.item.subject}</td>
            <td>
                <DateTimeView dateTime={props.item.createdTime} />
            </td>
            <td>
                <DateTimeView dateTime={props.item.sentTime} />
            </td>
            <td>
                <DateTimeView dateTime={props.item.failedTime} />
            </td>
            <td>
                <DateTimeView dateTime={props.item.desiredSendTime} />
            </td>
            <td>{props.item.from}</td>
            <td>
                <ButtonToolbar className="pull-right btn-group-sm">
                    <Button onClick={() => props.onView(props.item)} bsStyle="primary">
                        <i className="material-icons">edit</i>{' '}
                        {Translate(
                            'view-order/basic-order-info/modal/view-emails/button-labels/view-details'
                        )}
                    </Button>
                </ButtonToolbar>
            </td>
        </tr>
    );
};

export default EmailListRow;
